// Online store fields in the product and category editors (package flag `store`).
export const shopEn = {
  'shop.panel': 'Store',
  'shop.panelHint': 'Price, colours, sizes and stock. A product without a price is not for sale.',
  'shop.price': 'Price (Rp)',
  'shop.priceHint': 'Whole rupiah, e.g. 199000.',
  'shop.compareAt': 'Original price (Rp)',
  'shop.compareAtHint': 'Optional. Higher than the price: the product shows as on sale.',
  'shop.tags': 'Labels',
  'shop.tag.new': 'New',
  'shop.tag.sale': 'Sale',
  'shop.tag.bestseller': 'Best seller',
  'shop.colors': 'Colours',
  'shop.colorsHint': 'Each colour has its own swatch and photos; the product page switches photos with the colour.',
  'shop.addColor': 'Add colour',
  'shop.colorName': 'Colour name',
  'shop.colorKey': 'Key',
  'shop.colorKeyHint': 'Used in SKUs. Lowercase letters, digits, dashes.',
  'shop.colorHex': 'Swatch',
  'shop.colorPhotos': 'Photos of this colour',
  'shop.removeColor': 'Remove colour',
  'shop.sizes': 'Sizes',
  'shop.sizesHint': 'In the order shoppers see them.',
  'shop.preset.adult': 'XS – XL',
  'shop.preset.kids': 'Kids 110 – 150',
  'shop.preset.one': 'One size',
  'shop.addSize': 'Add size',
  'shop.newSize': 'New size',
  'shop.removeSize': 'Remove size {size}',
  'shop.stock': 'Stock per colour and size',
  'shop.stockHint': 'Empty: not sold in this colour and size. 0: sold out. Each cell gets its own SKU.',
  'shop.fill': 'Fill empty cells with',
  'shop.fillApply': 'Fill',
  'shop.stockCell': 'Stock, {color}, {size}',
  'shop.noGrid': 'Add at least one colour and one size to enter stock.',
  'shop.sku': 'SKU',
  'shop.totalStock': '{n} in stock across {cells} variants',
  'shop.lowStock': 'Low-stock alert at',
  'shop.lowStockHint': 'Under each stock number: at or under this many, the variant shows in Store → Low stock and the shop says "Only N left". New cells start at {n}.',
  'shop.lowStockCell': 'Low-stock alert, {color}, {size}',
  'shop.lowStockApply': 'Set for all',
  'shop.sizeGuide': 'Size guide',
  'shop.sizeGuideHint': 'Opened from every product page in this category. Leave empty for none.',
  'shop.sizeGuideColumns': 'Measurements (columns)',
  'shop.sizeGuideColumn': 'Column {n}',
  'shop.addColumn': 'Add column',
  'shop.addRow': 'Add size row',
  'shop.removeRow': 'Remove row',
  'shop.rowSize': 'Size',
  'shop.sizeGuideNote': 'Note under the table',
  'shop.locked': 'Your plan does not include the online store.',
} as const

export const shopId: Record<keyof typeof shopEn, string> = {
  'shop.panel': 'Toko',
  'shop.panelHint': 'Harga, warna, ukuran, dan stok. Produk tanpa harga tidak dijual.',
  'shop.price': 'Harga (Rp)',
  'shop.priceHint': 'Rupiah bulat, misalnya 199000.',
  'shop.compareAt': 'Harga awal (Rp)',
  'shop.compareAtHint': 'Opsional. Lebih tinggi dari harga: produk tampil sebagai diskon.',
  'shop.tags': 'Label',
  'shop.tag.new': 'Baru',
  'shop.tag.sale': 'Sale',
  'shop.tag.bestseller': 'Terlaris',
  'shop.colors': 'Warna',
  'shop.colorsHint': 'Tiap warna punya swatch dan foto sendiri; foto di halaman produk ikut berganti sesuai warna.',
  'shop.addColor': 'Tambah warna',
  'shop.colorName': 'Nama warna',
  'shop.colorKey': 'Kode',
  'shop.colorKeyHint': 'Dipakai di SKU. Huruf kecil, angka, tanda hubung.',
  'shop.colorHex': 'Swatch',
  'shop.colorPhotos': 'Foto warna ini',
  'shop.removeColor': 'Hapus warna',
  'shop.sizes': 'Ukuran',
  'shop.sizesHint': 'Sesuai urutan yang dilihat pembeli.',
  'shop.preset.adult': 'XS – XL',
  'shop.preset.kids': 'Anak 110 – 150',
  'shop.preset.one': 'All size',
  'shop.addSize': 'Tambah ukuran',
  'shop.newSize': 'Ukuran baru',
  'shop.removeSize': 'Hapus ukuran {size}',
  'shop.stock': 'Stok per warna dan ukuran',
  'shop.stockHint': 'Kosong: tidak dijual di warna dan ukuran ini. 0: habis. Tiap kotak punya SKU sendiri.',
  'shop.fill': 'Isi kotak kosong dengan',
  'shop.fillApply': 'Isi',
  'shop.stockCell': 'Stok, {color}, {size}',
  'shop.noGrid': 'Tambahkan minimal satu warna dan satu ukuran untuk mengisi stok.',
  'shop.sku': 'SKU',
  'shop.totalStock': '{n} stok di {cells} varian',
  'shop.lowStock': 'Peringatan stok menipis di',
  'shop.lowStockHint': 'Di bawah tiap angka stok: kalau stok sampai segini atau kurang, varian muncul di Toko → Stok menipis dan toko menulis "Tinggal N lagi". Kotak baru mulai dari {n}.',
  'shop.lowStockCell': 'Peringatan stok menipis, {color}, {size}',
  'shop.lowStockApply': 'Pakai untuk semua',
  'shop.sizeGuide': 'Panduan ukuran',
  'shop.sizeGuideHint': 'Dibuka dari setiap halaman produk di kategori ini. Kosongkan kalau tidak perlu.',
  'shop.sizeGuideColumns': 'Ukuran tubuh (kolom)',
  'shop.sizeGuideColumn': 'Kolom {n}',
  'shop.addColumn': 'Tambah kolom',
  'shop.addRow': 'Tambah baris ukuran',
  'shop.removeRow': 'Hapus baris',
  'shop.rowSize': 'Ukuran',
  'shop.sizeGuideNote': 'Catatan di bawah tabel',
  'shop.locked': 'Paket kamu belum termasuk toko online.',
}
